import { render } from "./Stocks.vue?vue&type=template&id=5b1b00d9&scoped=true&ts=true"
import script from "./Stocks.vue?vue&type=script&lang=ts"
export * from "./Stocks.vue?vue&type=script&lang=ts"

import "./Stocks.vue?vue&type=style&index=0&id=5b1b00d9&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1b00d9"]])

export default __exports__